import React, { Component } from "react";
import Grid from '../../../components/grid';
import Loader from "../../../components/loader";
import Axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { endOfWeek, format } from 'date-fns'
import "./style.scss";
import ReportDateRange from "../../../components/reportDateRange";

class HolidayPrintingReport extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        loading: true,
        report: [],
        endDate: endOfWeek(new Date()),
        columnDefs: [
            {
                headerName: "Company Name",
                field: "companyName"
            },
            {
                headerName: "Short Name",
                field: "companyShortName"
            },
            {
                headerName: "EIN",
                field: "EINName"
            },
            {
                headerName: "CSR",
                field: "CSR"
            },
            {
                headerName: "Payroll Name",
                field: "payrollName"
            },
            {
                headerName: "Pay Date",
                field: "payDate"
            },
            {
                headerName: "Payroll Status",
                field: "payrollStatus"
            },
            {
                headerName: "# Pay Statements",
                field: "numPSTs"
            }

        ]
    };

    getReport = async (endDate) => {
        let report = await Axios.get(`api/payroll/pst-printing-report/${endDate}`,).catch(e => e);
        return report?.data || []
    };

    runReport = async () => {
        this.setState({ loading: true });
        let report = await this.getReport(this.state.endDate);
        return this.setState({ loading: false, report });
    };

    async componentDidMount() {
        //let report = await this.getReport(this.state.defaultDate);
        await this.runReport();
        //this.setState({ loading: false, report });
    };

    render() {
        let { loading, report, columnDefs, endDate } = this.state;
        return (
            <div className="holiday-printing-report">
                <div className="table-header d-flex align-items-center justify-content-between">
                    <h4 className="heading_h3">PST Printing Report</h4>
                    <div className="d-flex align-items-center">
                        <div className="filter_inpt_sec position-relative date-range d-flex align-items-center">
                            <label className="label">Pay Date Up To</label>
                            {/* <DatePicker
                                selected={endDate}
                                onChange={this.setDate}
                                todayButton="Today"
                                highlightDates={[new Date()]}
                                customInput={<input />}
                            /> */}
                            <ReportDateRange
                                mode="single"
                                handleDateRange={(date) => { this.setState({ endDate: date }) }}
                                startDate={endDate}
                            />
                        </div>
                        <button className="ttuc primary report" onClick={this.runReport} disabled={loading || !endDate}>
                            {loading ? <span>Loading data </span> : <span>Run Report</span>}
                        </button>
                    </div>
                </div>
                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="filter-field d-flex">
                        </div>

                    </div>

                    {!loading ? <div className='loading-data'>
                        <Grid
                            enableRangeSelection={true}
                            rowData={report}
                            columnDefs={columnDefs}
                            height='600px'
                        >
                        </Grid>
                    </div> : <div className='loading-data d-flex align-items-center justify-content-center'> <Loader></Loader> </div>}


                </div>

            </div>
        );
    }
}
export default HolidayPrintingReport;
